import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { EditorEligibilityTree } from './editor-eligibility-tree.model';
import { EditorEligibilityTreeStore } from './editor-eligibility-tree.store';
import { EditorEligibilityOperatorEditStore } from '../editor-eligibility-operator-edit/editor-eligibility-operator-edit.store';
import { EditorEligibilityOperatorEditComponent } from '../editor-eligibility-operator-edit/editor-eligibility-operator-edit.component';


@Component({
    selector: 'eas-editor-eligibility-tree',
    templateUrl: './editor-eligibility-tree.component.html',
    styleUrls: ['./editor-eligibility-tree.component.css'],
    standalone: false
})
export class EditorEligibilityTreeComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  eligibilityTree: EditorEligibilityTree;

  constructor(
    private dialog: MatDialog,
    private eligibilityTreeStore: EditorEligibilityTreeStore,
    private operatorEditStore: EditorEligibilityOperatorEditStore
  ) {

  }

  ngOnInit() {
    this.eligibilityTreeStore.eligibilityTree$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(eligibilityTree => this.eligibilityTree = eligibilityTree);

    this.operatorEditStore.replacingOperatorWithRule$.pipe(
      takeUntil(this.destroyed$),
      filter(replacingOperatorWithRule => replacingOperatorWithRule !== null)
    ).subscribe(_ => this.dialog.open(EditorEligibilityOperatorEditComponent, {
      closeOnNavigation: true,
      disableClose: true,
      hasBackdrop: true,
      minWidth: '50vw',
    }));
  }

  ngOnDestroy() {
    this.eligibilityTreeStore.terminate();
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
